import { useCraftNode } from 'modules/forms-generator/hooks/useCraftNode'
import { useState } from 'react'
import ContentEditable from 'react-contenteditable'
import { useDispatch } from 'react-redux'
import { Settings } from '../../settings'
import { changeValue } from 'state/slices/formsGenerator/builderSlice'

export const ParagraphSetting = () => {
  return <Settings typography dimensions colors border display />
}

export const ParagraphComponent = ({ text, className = '', customId }) => {
  const [textValue, setTextValue] = useState(text)
  const dispatch = useDispatch()
  const {
    id,
    connectors: { connect, drag }
  } = useCraftNode()

  const handleChangeElement = ({ target }) => {
    setTextValue(target.value)
    dispatch(changeValue({ id: customId, key: 'value', value: target.value }))
  }

  return (
    <ContentEditable
      innerRef={(ref) => connect(drag(ref))}
      className={className}
      html={textValue}
      data-element-id={id}
      data-custom-id={customId}
      tagName='p'
      onChange={handleChangeElement}
    />
  )
}

ParagraphComponent.craft = {
  displayName: 'paragraph',
  props: {
    text: 'Text'
  },
  related: {
    toolbar: ParagraphSetting
  }
}
